import { render, staticRenderFns } from "./LobbiesTable.vue?vue&type=template&id=06878bb8&scoped=true&"
import script from "./LobbiesTable.vue?vue&type=script&lang=js&"
export * from "./LobbiesTable.vue?vue&type=script&lang=js&"
import style0 from "./LobbiesTable.vue?vue&type=style&index=0&id=06878bb8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06878bb8",
  null
  
)

component.options.__file = "LobbiesTable.vue"
export default component.exports